import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Link as MuiLink,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { CompanyRegistrationForm } from '../../components/Company/CompanyRegistrationForm';

export const CompanyRegisterPage: React.FC = () => {
  const handleSuccess = (companyId: number) => {
    console.log('企業登録成功:', companyId);
  };

  const handleError = (error: string) => {
    console.error('企業登録エラー:', error);
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        display: 'flex',
        alignItems: 'center',
        py: 4,
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={24}
          sx={{
            p: 4,
            borderRadius: 3,
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
          }}
        >
          {/* ヘッダー */}
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Typography
              variant="h3"
              component="h1"
              sx={{
                fontWeight: 'bold',
                background: 'linear-gradient(45deg, #667eea 30%, #764ba2 90%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                mb: 2,
              }}
            >
              企業アカウント登録
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ mb: 3 }}>
              不動産業界のDX化を支援するAI CRMシステム
            </Typography>
            <Typography variant="body1" color="text.secondary">
              企業アカウントを登録して、AI専門家による業務支援サービスをご利用ください
            </Typography>
          </Box>

          {/* 企業登録フォーム */}
          <CompanyRegistrationForm
            onSuccess={handleSuccess}
            onError={handleError}
          />

          {/* フッター */}
          <Box sx={{ mt: 4, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              個人アカウントをお持ちの方は{' '}
              <MuiLink
                component={Link}
                to="/auth/login"
                sx={{ textDecoration: 'none', fontWeight: 'bold' }}
              >
                こちらからログイン
              </MuiLink>
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              個人アカウントの登録は{' '}
              <MuiLink
                component={Link}
                to="/auth/register"
                sx={{ textDecoration: 'none', fontWeight: 'bold' }}
              >
                こちら
              </MuiLink>
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};
